var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "afterSale classification" }, [
    _c(
      "div",
      { staticStyle: { padding: "0px" } },
      [
        _c("StepWay", {
          attrs: {
            "step-array": [
              { name: "提交申请" },
              { name: "卖家审批" },
              { name: "买家退货" },
              { name: "卖家收货" },
              { name: "退款中" },
              { name: "完成" },
            ],
            "index-step": _vm.indexStep,
          },
          on: { stepBtn: _vm.stepBtn },
        }),
        _c(
          "div",
          { staticStyle: { display: "flex" } },
          [
            _c(
              "el-form",
              {
                ref: "ruleForm",
                staticClass: "demo-ruleForm",
                attrs: {
                  model: _vm.ruleForm,
                  rules: _vm.rules,
                  size: "small",
                  "label-width": "100px",
                },
              },
              [
                _c(
                  "el-form-item",
                  {
                    staticStyle: { display: "flex", "align-items": "center" },
                    attrs: { label: "售后商品", prop: "name" },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                          "margin-left": "-100px",
                        },
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: _vm.ruleForm.goodsImage || _vm.avater,
                            width: "100px",
                            alt: "",
                          },
                        }),
                        _c("div", { staticStyle: { "margin-left": "20px" } }, [
                          _c(
                            "p",
                            {
                              staticStyle: {
                                margin: "0",
                                "line-height": "20px",
                              },
                            },
                            [_vm._v(_vm._s(_vm.ruleForm.goodsName || ""))]
                          ),
                          _c(
                            "p",
                            {
                              staticStyle: {
                                margin: "0",
                                "line-height": "20px",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.ruleForm.goodsSpecification || "")
                              ),
                            ]
                          ),
                          _c(
                            "p",
                            {
                              staticStyle: {
                                margin: "0",
                                "line-height": "20px",
                              },
                            },
                            [_vm._v(_vm._s(_vm.ruleForm.goodsFactory || ""))]
                          ),
                          _c(
                            "p",
                            {
                              staticStyle: {
                                margin: "0",
                                "line-height": "20px",
                              },
                            },
                            [_vm._v(_vm._s(_vm.ruleForm.approvalNumber || ""))]
                          ),
                        ]),
                      ]
                    ),
                  ]
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "售后数量", prop: "qty" } },
                  [
                    _c("el-input-number", {
                      attrs: { min: 1, label: "售后数量" },
                      on: { change: _vm.changeQty },
                      model: {
                        value: _vm.ruleForm.qty,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "qty", $$v)
                        },
                        expression: "ruleForm.qty",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "售后方式", prop: "type" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "请选择售后方式" },
                        model: {
                          value: _vm.ruleForm.type,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "type", $$v)
                          },
                          expression: "ruleForm.type",
                        },
                      },
                      _vm._l(_vm.methodList, function (item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: { label: item.value, value: item.name },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "售后原因", prop: "afterSaleReason" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "请选择售后原因" },
                        model: {
                          value: _vm.ruleForm.afterSaleReason,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "afterSaleReason", $$v)
                          },
                          expression: "ruleForm.afterSaleReason",
                        },
                      },
                      _vm._l(_vm.reasonList, function (item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: { label: item.value, value: item.name },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "售后金额", prop: "amount" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "200px" },
                      attrs: { placeholder: "请输入" },
                      model: {
                        value: _vm.ruleForm.amount,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "amount", $$v)
                        },
                        expression: "ruleForm.amount",
                      },
                    }),
                    _vm._v(" 元 "),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "说明", prop: "remark" } },
                  [
                    _c("el-input", {
                      attrs: {
                        type: "textarea",
                        maxlength: "200",
                        "show-word-limit": "",
                        placeholder: "200字以内",
                      },
                      model: {
                        value: _vm.ruleForm.remark,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "remark", $$v)
                        },
                        expression: "ruleForm.remark",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticStyle: { "margin-bottom": "0px!important" },
                    attrs: { label: "图片" },
                  },
                  [
                    _c(
                      "ImgUpload",
                      {
                        staticStyle: { position: "relative", top: "-8px" },
                        attrs: { limit: 3 },
                        model: {
                          value: _vm.ruleForm.afterSaleVoucher,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "afterSaleVoucher", $$v)
                          },
                          expression: "ruleForm.afterSaleVoucher",
                        },
                      },
                      [
                        _c("template", { slot: "tip" }, [
                          _c(
                            "p",
                            {
                              staticClass: "el-upload__tip",
                              staticStyle: { margin: "0px" },
                            },
                            [
                              _vm._v(
                                " 备注:图片格式为jpg或png，建议尺寸100*100，图片大小不得超过5M;第一张图片会作为商品展示图 "
                              ),
                            ]
                          ),
                        ]),
                      ],
                      2
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.submitForm("ruleForm")
                          },
                        },
                      },
                      [_vm._v("提交")]
                    ),
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.resetForm("ruleForm")
                          },
                        },
                      },
                      [_vm._v("取消")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }